import { Controller } from "@hotwired/stimulus";

// Reveals a native "Share" button via the Web Share API when it's available
// (mobile browsers + Safari), opening the system share sheet. Where it isn't
// supported the button stays hidden and the copy-to-clipboard fallback shows.
//
//   <div data-controller="web-share"
//        data-web-share-url-value="https://…"
//        data-web-share-title-value="Join our org">
//     <button data-web-share-target="share" class="hidden" data-action="web-share#share">Share</button>
//     <button data-web-share-target="fallback">Copy link</button>
//   </div>
export default class extends Controller {
  static targets = ["share", "fallback"];
  static values = { url: String, title: String };

  declare readonly hasShareTarget: boolean;
  declare readonly shareTarget: HTMLElement;
  declare readonly hasFallbackTarget: boolean;
  declare readonly fallbackTarget: HTMLElement;
  declare readonly urlValue: string;
  declare readonly titleValue: string;

  connect() {
    if (!this.supported || !this.hasShareTarget) return;

    this.shareTarget.classList.remove("hidden");
    if (this.hasFallbackTarget) this.fallbackTarget.classList.add("hidden");
  }

  async share(event: Event) {
    event.preventDefault();
    if (!this.supported) return;

    try {
      await navigator.share({ title: this.titleValue, url: this.urlValue });
    } catch {
      // Dismissing the share sheet rejects with AbortError — nothing to do.
    }
  }

  get supported(): boolean {
    return typeof navigator !== "undefined" && typeof navigator.share === "function";
  }
}
